import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IGetPayoutAvailableMethodsStartPayload,
    IGetPayoutFormStartPayload,
    IPayoutAvailableMethods,
    IPayoutCancelActionPayload,
    IPayoutCancelSuccessPayload,
    IPayoutCreateActionPayload,
    IPayoutCreateSuccessPayload,
    IPayoutParams,
    IWithdrawalError,
    IWithdrawalState,
    IWithdrawalTransferParams,
    TWithdrawalPhase,
} from './withdrawal.t';
import { IAccountError } from '../Account/types/accountActions.t';
import { WITHDRAWAL_PHASES, WITHDRAWAL_TRANSFER_STATUS } from './withdrawalConstants';
import { IPaymentAvailableMethod, IPaymentForm } from "../Payment/payment.t";

const initialState: IWithdrawalState = {
    error: null,
    isInited: false,
    isCreateLoading: false,
    payoutAvailableMethods: [],
    payoutForm: [],
    payoutParams: {},
    payoutParamsSent: false,
    payoutSelectedMethod: null,
    phase: WITHDRAWAL_PHASES.FILL_FORM,

    transferParams: {
        amount: 0,
        isAuto: false,
        status: WITHDRAWAL_TRANSFER_STATUS.LOADING,
        transactionState: null,
        transactionUuid: '',
    },
};

const withdrawalReducer = createSlice({
    name: 'withdrawal',
    initialState,
    reducers: {
        withdrawalInitAction() {
        },
        withdrawalInitSuccess(state) {
            state.isInited = true;
        },

        withdrawalUnmountAction(state) {
            state.error = initialState.error;
            state.isInited = initialState.isInited;
            state.transferParams = { ...initialState.transferParams };
            state.phase = initialState.phase;
        },

        getPayoutParamsAction() {
        },
        getPayoutParamsSuccess(state, action: PayloadAction<IPayoutParams>) {
            state.payoutParams = action.payload;
            state.payoutParamsSent = true;
        },
        getPayoutParamsFailure(state) {
            state.payoutParamsSent = true;
        },


        getPayoutAvailableMethodsAction(state, action: PayloadAction<IGetPayoutAvailableMethodsStartPayload>) {
        },
        getPayoutAvailableMethodsSuccess(state, action: PayloadAction<IPayoutAvailableMethods>) {
            state.payoutAvailableMethods = action.payload || [];
        },
        getPayoutAvailableMethodsFailure(state, action: PayloadAction<IWithdrawalError>) {
            state.error = action.payload;
        },


        getPayoutFormAction(state, action: PayloadAction<IGetPayoutFormStartPayload>) {
        },
        getPayoutFormSuccess(state, action: PayloadAction<IPaymentForm>) {
            state.payoutForm = action.payload;
        },
        getPayoutFormFailure() {
        },


        payoutCreateAction(state, action: PayloadAction<IPayoutCreateActionPayload>) {
            state.error = null;
            state.isCreateLoading = true;
        },
        payoutCreateSuccess(state, action: PayloadAction<IPayoutCreateSuccessPayload>) {
            state.phase = WITHDRAWAL_PHASES.TRANSFER;
            state.isCreateLoading = false;
            state.transferParams = {
                ...state.transferParams,
                status: WITHDRAWAL_TRANSFER_STATUS.LOADING,
                ...action.payload,
            };
        },
        payoutCreateFailure(state, action: PayloadAction<IWithdrawalError>) {
            state.error = action.payload;
            state.isCreateLoading = false;
        },


        payoutCancelAction(state, action: PayloadAction<IPayoutCancelActionPayload>) {
        },
        payoutCancelSuccess(state, action: PayloadAction<IPayoutCancelSuccessPayload>) {
        },
        payoutCancelFailure(state, action: PayloadAction<IAccountError>) {
        },


        resetWithdrawalError(state) {
            state.error = null;
        },
        resetWithdrawalTransferParamsAction(state) {
            state.transferParams = { ...initialState.transferParams }
        },


        setWithdrawalPhaseAction(state, action: PayloadAction<TWithdrawalPhase>) {
            state.phase = action.payload;
        },
        setWithdrawalTransferParamsAction(state, action: PayloadAction<Partial<IWithdrawalTransferParams>>) {
            state.transferParams = { ...state.transferParams, ...action.payload };
        },
        setPayoutSelectedPaymentAction(state, action: PayloadAction<IPaymentAvailableMethod>) {
            state.payoutSelectedMethod = action.payload;
        },

        switchWithdrawalTransferStatusAction() {},
    },
});

export const {
    getPayoutAvailableMethodsAction,
    getPayoutAvailableMethodsFailure,
    getPayoutAvailableMethodsSuccess,
    getPayoutFormAction,
    getPayoutFormFailure,
    getPayoutFormSuccess,
    getPayoutParamsAction,
    getPayoutParamsFailure,
    getPayoutParamsSuccess,
    payoutCancelAction,
    payoutCancelFailure,
    payoutCancelSuccess,
    payoutCreateAction,
    payoutCreateFailure,
    payoutCreateSuccess,
    resetWithdrawalError,
    resetWithdrawalTransferParamsAction,
    setPayoutSelectedPaymentAction,
    setWithdrawalPhaseAction,
    setWithdrawalTransferParamsAction,
    switchWithdrawalTransferStatusAction,
    withdrawalInitAction,
    withdrawalInitSuccess,
    withdrawalUnmountAction,
} = withdrawalReducer.actions;
export default withdrawalReducer.reducer;
